import React from 'react';
import LogoImg from './logoimg';

export default class HeaderLogo extends React.Component {
  static propTypes = {
    displayLink: React.PropTypes.bool,
    logoLink:    React.PropTypes.string,
    altText:     React.PropTypes.string,
    onLoad:      React.PropTypes.func
  };

  render () {
    // if link is disabled
    if (!this.props.displayLink) {
      return <LogoImg {...this.props} onLoad={this.props.onLoad} />;
    }

    return (
      <a className="logo" href={this.props.logoLink} title={this.props.altText || 'Main page'}>
        <LogoImg {...this.props} onLoad={this.props.onLoad} />
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/logo/index.js